import {useContext} from 'react';
import PerformanceMonitorTrackStopSelfContext from 'src/internal/provider/PerformanceMonitorTrackStopSelfContext';

import type {PerformanceMonitorTrackStop} from 'src/types';

export default function usePerformanceMonitorTrackStop(): PerformanceMonitorTrackStop {
  return useContext(PerformanceMonitorTrackStopSelfContext);
}
